import { Component, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { FormsModule } from "@angular/forms";
import { ApiService } from '../../../../Services/api.service';
import { CommonModule } from '@angular/common';
import { uniq } from 'lodash';
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';

@Component({
  selector: 'app-add-lot-size',
  standalone: true,
  imports: [NzCollapseModule, NzButtonModule, FormsModule, CommonModule, NzSelectModule],
  templateUrl: './add-lot-size.component.html',
  styleUrl: './add-lot-size.component.scss'
})
export class AddLotSizeComponent {
  @Input() catalogId: string = '';
  @Input() selectedLot: string = '';
  @Output() emitAddData = new EventEmitter<string>();
  invalidForm: boolean = false;
  invalidPair: boolean = false;
  invalidList:boolean = false;
 @ViewChildren('size1Select') size1Components!: QueryList<NzSelectComponent>;
  constructor(private apiService: ApiService) {
  }
  lotArrList: any = [
    { id: 1, fieldName: "Size1", fieldType: "input", value: '', placeholder: "Enter Size1" },
    { id: 2, fieldName: "Size2", fieldType: "input", value: '', placeholder: "Enter Size2" },
    { id: 3, fieldName: "Clear", fieldType: "button", value: '', actionIds: [1, 2] }
  ];
  typeSizeMap: { [key: string]: string[] } = {};
  typeOptions: string[] = [];

  focusFirstSelect(): void {

    if (this.size1Components && this.size1Components.first) {
      this.size1Components.first.focus();
    }
  }

  ngAfterViewInit(){
    this.focusFirstSelect();
  }

  getLotFilterSizes() {
    this.apiService.getLotFilterSizes(this.selectedLot,this.catalogId).subscribe(res => {
      if (res && res.statusCode === 200) {
        this.typeSizeMap = {};

        res.data.forEach((item: any) => {
          const typeName = item[0];
          const sizes = item[1];
          this.typeSizeMap[typeName] = sizes;
        });

        this.typeOptions = Object.keys(this.typeSizeMap);
        this.updateRowOptions();
      }
    });
  }

  updateRowOptions() {
    this.lotArrList.forEach((panel: any) => {
      if (panel.placeholder === "Enter Size1") {
        panel.options = this.typeOptions;
      }
    });
  }

  onSize2Change(selectedValue: string, currentPanel: any) {
    if (currentPanel) {
    currentPanel.isMissingError = false;
  }
}

  onSize1Change(selectedValue: string, currentPanel: any) {
    if (currentPanel) {
    currentPanel.isMissingError = false;
  }
    const currentIndex = this.lotArrList.indexOf(currentPanel);
    const size2Panel = this.lotArrList[currentIndex + 1];

    if (size2Panel && size2Panel.placeholder === "Enter Size2") {
      if (this.typeSizeMap[selectedValue]) {
       if (!size2Panel.value) {
        size2Panel.value = '';
      }
        size2Panel.options = this.typeSizeMap[selectedValue];
      } else {
        size2Panel.options = [];
      }
    }

    this.validateLotSizes();
  }

  onSearch(searchText: string, panel: any): void {
    if (searchText) {
      panel.value = searchText.toUpperCase();

      if (panel.placeholder === 'Enter Size1') {
        this.onSize1Change(searchText, panel);
      }
    }

    this.validateLotSizes();
  }

  blockNonNumbers(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'Delete'];

    if (allowedKeys.includes(event.key)) {
      return;
    }


    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
      return;
    }

    const inputEl = event.target as HTMLInputElement;
    if (inputEl && inputEl.value.length >= 3) {
      event.preventDefault();
    }
  }

  blockNonUppercaseLetters(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Tab', 'Enter', 'Escape', 'ArrowLeft', 'ArrowRight', 'Delete'];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    const inputEl = event.target as HTMLInputElement;
    if (inputEl && inputEl.value.length >= 3) {
      event.preventDefault();
    }
  }



  addRow() {

    const lastId = this.lotArrList.length > 0
      ? this.lotArrList[this.lotArrList.length - 1].id
      : 0;

    this.lotArrList.push(
      { id: lastId + 1, fieldName: "", fieldType: "input", value: '', placeholder: "Enter Size1", maxLength: 2 },
      { id: lastId + 2, fieldName: "", fieldType: "input", value: '', placeholder: "Enter Size2", maxLength: 2 },
      { id: lastId + 3, fieldName: "Clear", fieldType: "button", value: '', placeholder: "", actionIds: [lastId + 1, lastId + 2] }
    );
  }

 


  handleSize2Tab(event: Event, currentPanel: any): void {
    
    const size2Panels = this.lotArrList.filter((p:any) => p.placeholder === 'Enter Size2');
    const currentIdx = size2Panels.findIndex((p:any) => p.id === currentPanel.id);

   
    if (currentIdx === size2Panels.length - 1) {
      event.preventDefault(); 
      this.addRow();

      setTimeout(() => {
        this.focusSize1AtRow(currentIdx + 1);
      }, 50);
    } else {
      event.preventDefault();
      this.focusSize1AtRow(currentIdx + 1);
    }
  }

  focusSize1AtRow(index: number): void {
    if (this.size1Components) {
      const size1Array = this.size1Components.toArray();
      if (size1Array[index]) {
        size1Array[index].focus();
      }
    }
  }
  clearRow(data: any) {
    this.lotArrList.map((res: any) => {
      if (data.actionIds.includes(res.id)) {
        res.value = '';
      }
    })
    this.validateLotSizes();
  }

  resetForm() {
    this.lotArrList.map((res: any) => {
      if (res?.value) {
        res.value = '';
      }
    })
  }

  saveRow() {
    if (!this.validateLotSizes() || !this.validateLotValues()) {
      return
    }
    const valid = this.lotArrList.filter((res: any) => res.value);
    if (valid.length >= 2) {
      this.invalidForm = false;
      const addedPairs = valid.reduce((acc: any, curr: any, index: any, arr: any) => {
        if (index % 2 == 0 && arr[index + 1]) {
          acc.push({
            dim1: curr.value,
            dim2: arr[index + 1].value
          })
        }
        return acc;
      }, []);
      this.emitAddData.emit(addedPairs);
    }
    else {
      this.invalidForm = true;
    }
  }

  validateLotSizes() {
    this.invalidPair = false;

    const seenCombinations = new Set<string>();

    for (let i = 0; i < this.lotArrList.length; i += 3) {
      const rowSize1 = this.lotArrList[i];
      const rowSize2 = this.lotArrList[i + 1];
      if (rowSize1?.value && rowSize2?.value) {
        const combinationKey = `${rowSize1.value.toString().trim()}-${rowSize2.value.toString().trim()}`;

        if (seenCombinations.has(combinationKey)) {
          this.invalidPair = true;
          return false;
        }

        seenCombinations.add(combinationKey);
      }
    }

    return true;
  }


validateLotValues(): boolean {
  this.invalidList = false;

  this.lotArrList.forEach((item:any) => {
    if (item) item.isMissingError = false;
  });

  if (this.isListEmpty()) {
    this.invalidList = true;
    return false;
  }

  if (this.hasIncompletePairs()) {
    // this.invalidPair = true;
    return false;
  }

  return true;
}

 isListEmpty(): boolean {
  if (!this.lotArrList || this.lotArrList.length === 0) {
    return true;
  }
  return this.lotArrList.every((item:any) => !item?.value);
}
 hasIncompletePairs(): boolean {
  let foundIncomplete = false;

  for (let i = 0; i < this.lotArrList.length; i += 3) {
    const rowSize1 = this.lotArrList[i];
    const rowSize2 = this.lotArrList[i + 1];

    const hasFirst = !!rowSize1?.value;
    const hasSecond = !!rowSize2?.value;

    if (hasFirst && !hasSecond) {
      if (rowSize2) rowSize2.isMissingError = true;
      foundIncomplete = true;
    } 
    else if (!hasFirst && hasSecond) {
      if (rowSize1) rowSize1.isMissingError = true;
      foundIncomplete = true;
    }
  }

  return foundIncomplete;
}


  ngOnInit() {
    for (let i = 0; i < 9; i++) {
      this.addRow();
    }
    this.getLotFilterSizes();
  }

};

